import React from 'react'
import clsx from 'clsx'
import { Bot, XCircle } from 'lucide-react'
import { useAIAlerts } from '../../hooks/useAIAlerts'
import { AlertItem } from './AlertItem'
import styles from './AIAlertPanel.module.css'

export interface AIAlertPanelProps {
  sessionId?: string
  className?: string
}

export function AIAlertPanel({ sessionId: _, className }: AIAlertPanelProps) {
  const { alerts, unreadCount, dismiss, dismissAll } = useAIAlerts()

  return (
    <aside className={clsx(styles.panel, className)} aria-label="AI Coordinator Alerts">
      <div className={styles.header}>
        <Bot size={16} />
        <span className={styles.title}>AI Coordinator</span>
        {unreadCount > 0 && (
          <span className={styles.badge}>{unreadCount}</span>
        )}
        {alerts.length > 0 && (
          <button
            type="button"
            className={styles.clearBtn}
            onClick={dismissAll}
            aria-label="Dismiss all alerts"
            title="Dismiss all"
          >
            <XCircle size={14} />
          </button>
        )}
      </div>

      <div className={styles.list}>
        {alerts.length === 0 ? (
          <div className={styles.empty}>
            <span>✅ No active alerts</span>
            <span className={styles.emptyHint}>AI is monitoring session…</span>
          </div>
        ) : (
          alerts.map((alert) => (
            <AlertItem
              key={alert.id}
              alert={alert}
              onDismiss={() => dismiss(alert.id)}
            />
          ))
        )}
      </div>
    </aside>
  )
}
